import React from 'react'

import { Button, SubmitButton } from '@offerzen/pinata-shame'
import unicorn from '../../../assets/unicorn-primary.svg'

import { resumeParsingStatuses } from '../../../CandidateExperience/hooks'
import ImportingResumeSpinner from '../../../CandidateExperience/components/ImportingResumeSpinner'
import ImportingResumeSuccess from '../../../CandidateExperience/components/ImportingResumeSuccess'
import ResumeContainer from '../../containers/ResumeContainer'
import Card from '../../components/Card'
import ResumeForm from '../../components/ResumeForm'

import styles from './styles'

const ResumeScene = () => (
  <ResumeContainer>
    {({
      candidate,
      loadingCandidate,
      updateCandidate,
      importResume,
      isParsingResume,
      hasPolledTooManyTimes,
      resumeParsingExecutionStatus,
      resumeParsingExecution,
      trackSelectedFile,
      resetResumeParser,
    }) => (
      <Card title={`Welcome to OfferZen, ${candidate.first_name}!`} width={550} imageUrl={unicorn}>
        <Choose>
          <When condition={isParsingResume}>
            <ImportingResumeSpinner />
            <div className={styles.cardFooter}>
              <Button label="Next" size="medium" disabled />
            </div>
          </When>
          <When condition={resumeParsingExecutionStatus === resumeParsingStatuses.COMPLETED}>
            <ImportingResumeSuccess
              // eslint-disable-next-line react/jsx-props-no-spreading
              {...resumeParsingExecution}
            />
            <div className={styles.cardFooter}>
              <SubmitButton label="Next" type="button" isSubmitting={loadingCandidate} onClick={updateCandidate} />
            </div>
          </When>
          <Otherwise>
            <ResumeForm
              importResume={importResume}
              resumeParsingExecutionStatus={resumeParsingExecutionStatus}
              resumeParsingExecution={resumeParsingExecution}
              hasPolledTooManyTimes={hasPolledTooManyTimes}
              trackSelectedFile={trackSelectedFile}
              updateCandidate={updateCandidate}
              loadingCandidate={loadingCandidate}
              resetResumeParser={resetResumeParser}
            />
          </Otherwise>
        </Choose>
      </Card>
    )}
  </ResumeContainer>
)

export default ResumeScene
